export const OFFSET = 0;
export const SEARCHBAR_OFFESET = 34;
export const RESPONSIVE_LEVELS = {
  DEFAULT: 'default',
  NO_LABEL: 'no-label',
  INSIDE_MORE: 'inside-more',
};
export const BUTTON_KINDS = {
  SAVI: 'Copilot',
  FILTER: 'Filters',
  GROUP_BY: 'Group By',
  ROWS: 'Rows',
  COLUMNS: 'Columns',
  SORT: 'Sort',
  MORE: 'More',
};

// Hidden For Beta
// - Group By

export const INITIAL_CONTROL_BUTTON_CONDITIONS = [
  { id: BUTTON_KINDS.SAVI, isVisible: true, shouldRender: false },
  { id: BUTTON_KINDS.FILTER, isVisible: true, shouldRender: true },
  { id: BUTTON_KINDS.GROUP_BY, isVisible: true, shouldRender: true },
  { id: BUTTON_KINDS.ROWS, isVisible: true, shouldRender: true },
  { id: BUTTON_KINDS.COLUMNS, isVisible: true, shouldRender: true },
  { id: BUTTON_KINDS.SORT, isVisible: true, shouldRender: true },
  { id: BUTTON_KINDS.MORE, isVisible: false },
];
